import { Comment } from 'uiComponents/comment/comment'
import { PaymentPeriod } from 'products/pricing/pricingPlans'

export type MembershipStatus = 'active' | 'inactive' | 'overdue'

interface MembershipArticle {
    id: number
    uuid: string
    name: string
}

export interface Member {
    firstName: string
    lastName: string
    phoneNumber: string
    streetName: string
    country: string
    city: string
    zipCode: string
    photo: string
    dateOfBirth: string
}

export interface Membership {
    uuid: string
    status: MembershipStatus
    membershipId: string
    email: string
    member: Member
    article: MembershipArticle
    expiresAt: string
    autoRenewEnabled: boolean
    createdAt: string
    barcode: string
    orderUuid: string
    orderNumber: string
}

export interface MembershipBilling {
    linkedEmail: string
    paymentMethod: string
    paymentMethodDetails: string
    cardBrand: string
    expirationDate: string
    paymentSchedule: PaymentPeriod
    nextPayment: string | null
}

export enum MembershipPaymentStatus {
    PAID = 'PAID',
    FAILED = 'FAILED',
    REFUNDED = 'REFUNDED',
    REFUND_IN_PROGRESS = 'REFUND_IN_PROGRESS',
    CHARGED_BACK = 'CHARGED_BACK',
    OPEN = 'OPEN',
    PENDING = 'PENDING',
    CANCELLED = 'CANCELLED',
    OVERDUE = 'OVERDUE',
}

export interface MembershipPayment {
    id: string
    amount: number
    currency: string
    paymentDate: string
    status: MembershipPaymentStatus
}

export interface MembershipRetryPayment extends MembershipPayment {
    dueDate: string
    membershipUuid: string
}

export interface MembershipPaymentRetry {
    latestDate: string
    memberships: Membership[]
    payments: MembershipRetryPayment[]
    upcoming: MembershipRetryPayment[]
}

export interface MembershipDetailed extends Membership {
    barcode: string
    billing: MembershipBilling
    payments: MembershipPayment[]
    upcomingPayment: Omit<MembershipPayment, 'id'> | null
    paymentRetry: MembershipPaymentRetry | null
    comments: Comment[]
}
